import { fetchInventory } from '../../services/killshot';

export const refreshInventoryAction = () => ({
  type: 'REFRESH_INVENTORY',
});

export const resetRefreshInventoryAction = () => ({
  type: 'RESET_REFRESH_INVENTORY',
});

export const resetRefreshGroupsAction = () => ({
  type: 'RESET_REFRESH_GROUPS',
});

export const fetchInventorySuccess = inventory => ({ type: 'INVENTORY_FETCH_SUCCESS', payload: inventory });

export const loadingInventoryAction = loading => ({ type: 'LOADING_INVENTORY', payload: loading });

export const fetchGroupedListingsSuccess = groupedListings => ({
  type: 'GROUPED_LISTINGS_FETCH_SUCCESS',
  payload: groupedListings,
});

export const loadingGroupedListingsAction = loading => ({ type: 'LOADING_GROUPED_LISTINGS', payload: loading });

export const setGroupsOpenned = groups => ({ type: 'SET_GROUPS_OPENNED', payload: groups });

export const setGroupFocused = group => ({ type: 'SET_GROUPS_FOCUSED', payload: group });

export const refreshInventory = sbId => dispatch => {
  fetchInventory(sbId, false)
    .then(groupedResponse => {
      dispatch(loadingInventoryAction(true));
      dispatch(fetchInventorySuccess(groupedResponse?.response));
      dispatch(loadingInventoryAction(false));
    })
    .catch(err => {
      dispatch(loadingInventoryAction(false));
      throw err;
    });
};

export const refreshGroupedListings = sbId => async dispatch => {
  try {
    const groupedResponse = await fetchInventory(sbId, true);
    dispatch(loadingGroupedListingsAction(true));
    dispatch(fetchGroupedListingsSuccess(groupedResponse?.response));
    dispatch(loadingGroupedListingsAction(false));
  } catch (err) {
    dispatch(loadingGroupedListingsAction(false));
    throw err;
  }
};
